export const NUMBER_FILTER_VALUES = {
    min: 0,
    max: 1000,
    step: 1,
};
